export enum selectorType {
  payByMyself = 'payByMyself',
  payByMyselfGroup = 'payByMyselfGroup',
  usePrePaidCode = 'usePrePaidCode',
  usePrePaidCodeGroup = 'usePrePaidCodeGroup',
  prePayForOthers = 'prepaidAwardsEntrySelector',
  prePayForOthersGroup = 'prepaidAwardsEntrySelectorGroup',
}
